<template>
  <div class="mine-page">
    <div class="header">
      <UserCard
        :role="USER_ROLES.CLIENT_AGENT"
        :user="user"
        :store="currentStore"
      />
    </div>
    <div>
      <CCell title="店铺名称" :value="user?.storeName" />
      <CCell
        v-if="canSwitchRole"
        title="切换为店长"
        is-link
        @click="onSwitch"
      />
      <CCell title="面对面发货" is-link @click="onScan" />
    </div>
    <CConfirm ref="refCConfirm" />
  </div>
</template>

<script>
import CCell from "@/components/common/CCell.vue";
import CConfirm from "@/components/common/CConfirm.vue";
import UserCard from "@/components/common/UserCard.vue";
import { USER_ROLES } from "@/consts";
import normalPage from "@/mixins/normal-page";
import { parseHashQueryString } from "@/utils/string";
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  mixins: [normalPage],
  components: { UserCard, CCell, CConfirm },
  data() {
    return {
      USER_ROLES,
    };
  },
  computed: {
    ...mapState(["account", "user"]),
    ...mapGetters(["currentStore", "canSwitchRole"]),
  },
  watch: {
    "account.role": {
      deep: true,
      handler(role) {
        if (role === USER_ROLES.STORE_MANAGER) {
          this.$router.replace({ name: "StoreManagerMy" });
        } else if (role === USER_ROLES.REGION_MANAGER) {
          this.$router.replace({ name: "AreaManagerMy" });
        }
      },
    },
  },
  methods: {
    ...mapActions(["switchSMRole"]),
    async onSwitch() {
      try {
        await this.$refs.refCConfirm.show("确定切换用户身份吗？");
        await this.switchSMRole(USER_ROLES.STORE_MANAGER);
      } catch (error) {
        console.log("cancel switch");
      }
    },
    async onScan() {
      wx.scanQRCode({
        needResult: 1,
        desc: "面对面发货",
        scanType: ["qrCode", "barCode"],
        success: (res) => {
          if (res.errMsg === "scanQRCode:ok") {
            console.log("onScan resultStr", res.resultStr);
            if (res.resultStr?.includes("#/sa/order")) {
              const query = parseHashQueryString(res.resultStr);
              if (query.orderNo) {
                return this.$router.push({
                  name: "Order",
                  query,
                });
              }
            }
            this.$toast("请扫描客人提供的核销码");
          } else {
            console.log("onScan notOk", res.errMsg);
            this.$toast(res.errMsg);
          }
        },
        fail: function (err) {
          console.error("onScan fail", err);
          if (err.errMsg.indexOf("function_not_exist") > 0) {
            this.$toast("版本过低请升级");
          }
        },
        error: function (err) {
          console.error("onScan error", err);
          if (err.errMsg.indexOf("function_not_exist") > 0) {
            this.$toast("版本过低请升级");
          }
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.mine-page {
  width: 100vw;
  height: 100%;
  background-color: #fff;
}

.header {
  width: 100vw;
  height: 328/20rem;
}
</style>
